import { Control } from "react-hook-form";
import { FormTextField } from "components/Forms/FormTextField";

interface MergedWasteStreamInternalNotesInputProps {
  control: Control<any>;
}

export const MergedWasteStreamInternalNotesInput = ({
  control,
}: MergedWasteStreamInternalNotesInputProps) => {
  return (
    <FormTextField
      name="internalNote"
      label="Internal Note"
      control={control}
      textFieldProps={{
        multiline: true,
      }}
      inputProps={{
        placeholder: "Add Note",
      }}
      InputLabelProps={{
        shrink: true,
      }}
      hideErrors={true}
      fullWidth
    />
  );
};